// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zqsplqanudzicoyjfpad.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpxc3BscWFudWR6aWNveWpmcGFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ0NzI0MjMsImV4cCI6MjA5MDA0ODQyM30.b4ARvZaxe90Q20JbuUNK3VRjJJLctvMlVphrRzAObQ0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});